export default [
  {
    delivery_time: "Forventet levering",
    download_receipt: "Download kvittering",
    need_help: "Har du brug for hjælp til din ordre?",
    need_help_description:
      "Vi har sendt dig et link, hvor du kan følge med hvor langt din ordre er. Du kan nemt åbne chatten og høre omkring din levering. Her er dit ordre nummer: ",
    order_canceled: "Ordren annulleret",
    order_no_paid: "Ordre er ikke betalt",
    pickup_time: "Forventet klar",
    step1: "Modtaget",
    step1_description: "Din ordre er ved at blive gjort klar.",
    step2: "Bekræftet",
    step2_description: "Din ordre er gjort klar og på vej til dig nu.",
    step3: "Klar",
    step2Pickup: "Bekræftet",
    step2_descriptionPickup: "Din bestilling er klar og kan afhentes nu.",
    need_help_descriptionPickup:
      "Følg din ordre status her. Hvis du har nogle spørgsmål så kan du kontakte os direkte. Dit ordre nummer er: ",
    step3Pickup: "Klar",
    thank_you_title: "Tak for din bestilling!",
    thank_you_description:
      "Din ordre er blevet oprettet. Vent venligst, restauranten skal godkende den snart.",
    restaurant_info_title: "Restaurant information:",
    order_info_title: "Ordre information:",
    order_number: "Dit ordrenummer:",
    payment_status_title: "Betalingsstatus",
    payment_status_paid_online: "Ordren er allerede betalt online",
    payment_status_description:
      "Ordren er ikke betalt endnu - betaling skal gennemføres i restauranten.",
    need_help_title: "Har du brug for hjælp med din ordre?",
    need_help_text:
      "Du kan følge din ordrestatus her. Hvis du har spørgsmål, er du velkommen til at kontakte os direkte. Dit ordrenummer er:",
    overview_title: "Oversigt",
    download_invoice: "Download faktura",
    send_receipt: "Send kvittering til email",
    step4: "Gennemført",
    received_description:
      "Din ordre er oprettet. Vent venligst – restauranten skal lige godkende din bestilling.",
    confirmed_description: "Restauranten har bekræftet din bestilling.",
    ready_description: "Din bestilling er klar.",
    completed_description: "Din bestilling er gennemført. Velbekomme!",
    order_cancelled_description:
      "Din bestilling er desværre blevet annulleret. Kontakt os endelig, hvis du har spørgsmål eller brug for hjælp.",
  },
];
